import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const recordingsPlugin = createPlugin({
  id: 'recordings',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindRecordingsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(recordingsPlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};

export const ConfidenceRecordingsPage = recordingsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceRecordingsPage',
    component: () =>
      import(/* webpackChunkName: "confidence-recordings" */ './Router').then(
        m => m.Router,
      ),
    mountPoint: rootRouteRef,
  }),
);
